import gsap from 'gsap/all';
import { component } from 'picoapp';

export default component((node, ctx) => {
  const LOCAL_STORAGE_KEY = 'roastworks-accepted-cookies';
  const cookiesAccepted = localStorage.getItem(LOCAL_STORAGE_KEY);
  const message = node.querySelector('.js-cookies-message');

  const showCookieNotice = () => {
    gsap.set(node, { autoAlpha: 1, duration: 0.5 });
    gsap.fromTo(message,
      { y: '200%' },
      { y: '0%', duration: 1, ease: 'power1.out' });
  };

  const hideCookieNotice = () => {
    gsap.set(node, { autoAlpha: 0, duration: 0.5 });
    gsap.fromTo(message,
      { y: '0%' },
      { y: '100%', duration: 1, ease: 'power1.out' });
  };

  const acceptCookies = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, true);
    hideCookieNotice();
  };

  const addEventListeners = () => {
    const close = node.querySelector('.js-close-cookies');
    const accept = node.querySelector('.js-accept-cookies');

    close.addEventListener('click', hideCookieNotice);
    accept.addEventListener('click', acceptCookies);
  };

  if (!cookiesAccepted) {
    showCookieNotice();
    addEventListeners();
  }

});